import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import AppContext from '../../Services/AppContext';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, { axiosDefaultConfig, axiosPutConfig, axiosURIencode } from '../../Services/API_Service';
import PersistantData from '../../Services/PersistantData';
import {
	mapbox_key,
	req_cust,
	req_cust_excel,
	req_cust_category,
	req_cust_category_status,
	req_cust_chain,
	req_cust_chain_status,
	req_cust_status,
	req_mobile_module_setting,
	req_module_setting,
	req_salesman,
	req_cust_type,
	req_cust_type_status,
	req_cust_branches,
	req_cust_area,
	req_stocktemplate,
	req_check_outlet_management_status,
	req_outlet_schedule_summary,
	req_cust_area_status
} from '../../Helper/Constants';
import { makeStyles, useTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Chip, CircularProgress, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import { grey, red } from '@material-ui/core/colors';
import MUIDataTable from 'mui-datatables';
import _ from 'lodash';
import useStateCallback from '../../Services/StateCallback';
import ShimmerLoading from '../../Components/ShimmerLoading';
import moment from 'moment';
import CustomerDetails from '../../Components/CustomerDetails';
import { de, getSetting } from '../../Helper/Helper';
import Tooltip from "@material-ui/core/Tooltip";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AddIcon from '@material-ui/icons/Add';
import AddCustomer from '../../Components/AddCustomer';
import OutletInactivateDialog from '../../Components/OutletInactivateDialog';
import DataTableFilter, { createDataTableFilterTheme, isColumnDisplayed, splitFilterValues } from '../../Components/DataTableFilter';
import useColumnPreference from '../../Services/useColumnPreference';
import OutletActivateDialog from '../../Components/OutletActivateDialog';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { BottomNavigation, BottomNavigationAction, IconButton, Tab, Tabs } from '@material-ui/core';
import { useCommonStyles } from '../../Styles';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import Button from '@material-ui/core/Button';
import AddCustCategory from '../../Components/AddCustCategory';
import AddCustChain from '../../Components/AddCustChain';
import CustCategoryDetails from '../../Components/CustCategoryDetails';
import CustChainDetails from '../../Components/CustChainDetails';
// 仅旧Agent Select筛选器使用，该筛选器已停用（见headCells agent列）
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
// import Checkbox from '@material-ui/core/Checkbox';
// import ListItemText from '@material-ui/core/ListItemText';
import MapIcon from '@material-ui/icons/Map';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { pure } from 'recompose';
import ReactMapboxGl, { Marker, Popup } from 'react-mapbox-gl';
import RoomIcon from '@material-ui/icons/Room';
import AddCustType from '../../Components/AddCustType';
import CustTypeDetails from '../../Components/CustTypeDetails';
import GoogleMap from '../../Components/GoogleMap';
import AddAreaType from '../../Components/AddAreaType';
import CustAreaDetails from '../../Components/CustAreaDetails';
import BulkImport from './BulkImport';

const useStyles = makeStyles((theme) => ({
	sectionTitle: {
		color: grey[500],
		marginLeft: theme.spacing(1),
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
	left: {
		marginLeft: theme.spacing(1)
	},
	fontGrey: {
		color: 'grey'
	},
	marginTop: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(3)
	}
}));

// custom筛选的过滤逻辑，返回true代表该行被筛掉
const filterValueLogic = (value, filters) => {
	if (!filters || filters.length === 0) {
		return false;
	}
	const current = value === null || value === undefined ? '' : String(value).trim();
	return filters.indexOf(current) === -1;
};

// 多值列（如Agent "(a) a, (b) b"）：拆开后任一值命中即保留
const MULTI_VALUE_FILTER_SEPARATOR = { agent: ',' };

// 显示截断文字，但把完整value挂在props上，MUIDataTable筛选时读取的是完整值
const TruncatedCell = ({ value, length }) => _.truncate(value, { length });

const multiValueFilterLogic = (separator) => (value, filters) => {
	if (!filters || filters.length === 0) {
		return false;
	}
	const parts = splitFilterValues(value, separator);
	return !parts.some(part => filters.indexOf(part) !== -1);
};

export default function Customer() {
	const classes = useStyles();
	const commonStyles = useCommonStyles();
	const [gState] = useContext(AppContext);

	const [config, setConfig] = useState({
		orderType: []
	});
	const [choosenCustType, setChoosenCustType] = useState({});
	const [choosenCustArea, setChoosenCustArea] = useState({});
	const [modules, setModules] = useState({});
	const [customerGroups, setCustomerGroups] = useState({});
	const [customerList, setCustomerList] = useState([]);
	const [inactiveCustList, setInactiveCustList] = useState([]);
	const [loginList, setLoginList] = useState([]);
	// const [customerIndexedList, setCustomerIndexedList] = useStateCallback({}, () => {
	// });
	// const [inactiveCustomerIndexedList, setInactiveCustomerIndexedList] = useStateCallback({}, () => {
	// });
	const [chosenCustomer, setChosenCustomer] = useState({});
	const [showCustomerDetails, toggleCustomerDetails] = useState(false);
	const [integration, setIntegration] = useState(1);

	const [axiosConfig, setAxiosConfig] = useState({});
	const [axiosPut, setAxiosPutConfig] = useState({});

	const { enqueueSnackbar } = useSnackbar();
	const [createDialog, showCreateDialog] = useState(false);

	const [showInactiveCustCategory, setShowInactiveCustCategory] = useState(false);
	const [showInactiveCustType, setShowInactiveCustType] = useState(false);
	const [showInactiveCustChain, setShowInactiveCustChain] = useState(false);
	const [showInactiveCustArea, setShowInactiveCustArea] = useState(false);
	const [showInactiveCust, setShowInactiveCust] = useState(false);

	const [currentPage, setCurrentPage] = useState(0);
	const [tabPosition, setTabPosition] = useState(0);
	const [customerChainList, setCustomerChainList] = useState([]);
	const [customerCategoryList, setCustomerCategoryList] = useState([]);
	const [customerTypeList, setCustomerTypeList] = useState([]);
	const [customerAreaList, setCustomerAreaList] = useState([]);
	const [newCustChainView, setNewCustChainView] = useState(false);
	const [newCustCategoryView, setNewCustCategoryView] = useState(false);
	const [newCustTypeView, setNewCustTypeView] = useState(false);
	const [newCustAreaView, setNewCustAreaView] = useState(false);
	const [showCustCategoryDetails, toggleCustCategoryDetails] = useState(false);
	const [chosenCustCategory, setChosenCustCategory] = useState(-1);
	const [showCustChainDetails, toggleCustChainDetails] = useState(false);
	const [showCustTypeDetails, toggleCustTypeDetails] = useState(false);
	const [showCustAreaDetails, toggleCustAreaDetails] = useState(false);
	const [chosenCustChain, setChosenCustChain] = useState(-1);
	const [activeCustCategoryList, setActiveCustCategoryList] = useState([]);
	const [inactiveCustCategoryList, setInactiveCustCategoryList] = useState([]);
	const [activeCustChainList, setActiveCustChainList] = useState([]);
	const [activeCustTypeList, setActiveCustTypeList] = useState([]);
	const [inactiveCustTypeList, setInactiveCustTypeList] = useState([]);
	const [activeCustAreaList, setActiveCustAreaList] = useState([]);
	const [inactiveCustAreaList, setInactiveCustAreaList] = useState([]);
	const [inactiveCustChainList, setInactiveCustChainList] = useState([]);
	const [loadingStatus, setLoadingStatus] = useState({});
	const [custLoaded, setCustLoaded] = useState(false);
	const [salespersonList, setSalespersonList] = useState([]);
	const [mobileCustomization, setMobileCustomization] = useState({});
	const [branchesList, setBranchesList] = useState([]);
	const [stockTemplateList, setStockTemplateList] = useState([]);

	const [confirmDialog, setConfirmDialog] = useState({
		open: false,
		title: '',
		content: '',
		onConfirm: null
	});

	const [scheduleDialog, setScheduleDialog] = useState({
		open: false,
		cust_code: '',
		outletName: '',
		summary: null,
		loading: false
	});

	const [activateDialog, setActivateDialog] = useState({
		open: false,
		cust_code: '',
		outletName: '',
		loading: false
	});

	const [customerTable, setCustomerTable] = useState({
		customerIndexedList: {},
		inactiveCustomerIndexedList: {},
		customerList: [],
		inactiveCustList: [],
		salespersonList: [],
		mapLatlongList: []
	});

	const singleton = PersistantData.getInstance();
	var { translation: language } = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang();
	}

	const theme = useTheme();
	const lightTheme = theme.palette.type === 'light';
	const [latlongList, setLatlongList] = useState([]);
	const [tableHeader, setTableHeader] = useState([]);
	// 以列名为key保存当前筛选条件，columns重建时回填，避免筛选被清空
	const filterListRef = useRef(null);
	// 当前展示的客户数据，供Filter弹窗统计选项
	const customerDataRef = useRef([]);

	// 装饰列：Filter弹窗按MUIDataTable实时列可见状态只渲染显示中的列，并回填已选筛选条件（与Check-in一致）
	const redefineHeaders = (columns) => {
		return columns.map(col => {
			// Status列依赖loadingStatus/changeCustomerStatus，在此用最新闭包重建（列固定后不再随每次render重建）
			if (col.name === 'customer_status') {
				const statusOptions = { ...col.options };
				statusOptions.customBodyRender = (value, tableMeta) => {
					const { rowData } = tableMeta;
					const cust_code = rowData[0];
					const cust_company_name = rowData[1];
					var customerStatus = parseInt(value);

					const onChangeStatus = (e) => {
						e.stopPropagation();
						changeCustomerStatus(cust_code, customerStatus, cust_company_name);
					}

					if (loadingStatus[cust_code]) {
						return <CircularProgress size={40} />;
					}

					if (customerStatus === 1) {
						return (
							<IconButton onClick={onChangeStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else if (customerStatus === 0) {
						return (
							<IconButton onClick={onChangeStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				};
				return { ...col, options: statusOptions };
			}
			const options = { ...col.options };
			if (options.filter !== false) {
				options.filter = true;
			}
			const savedFilter = filterListRef.current && filterListRef.current[col.name];
			if (savedFilter) {
				options.filterList = savedFilter;
			}
			if (options.filter) {
				const separator = MULTI_VALUE_FILTER_SEPARATOR[col.name];
				options.filterType = 'custom';
				options.filterOptions = {
					logic: separator ? multiValueFilterLogic(separator) : filterValueLogic,
					display: (filterList, onChange, index, column) => isColumnDisplayed(column) && (
						<DataTableFilter
							index={index}
							name={column.name}
							label={column.label}
							rows={customerDataRef.current}
							selected={filterList[index] || []}
							onChange={(values) => onChange(values, index, column)}
							language={language}
							separator={separator}
						/>
					)
				};
				options.customFilterListOptions = {
					render: (values) => values.map(value => `${col.label}: ${value}`),
					update: (filterList, filterPos, index) => {
						filterList[index].splice(filterPos, 1);
						return filterList;
					}
				};
			}
			return { ...col, options };
		});
	};

	// 按列名快照当前筛选条件，columns重建时回填（经ref读tableHeader，保持回调引用稳定供memo化的CustomerTable使用）
	const tableHeaderRef = useRef([]);
	tableHeaderRef.current = tableHeader;
	const onCustomerFilterChange = useCallback((changedColumn, filterList) => {
		const snapshot = {};
		tableHeaderRef.current.forEach((col, index) => {
			snapshot[col.name] = filterList[index] || [];
		});
		filterListRef.current = snapshot;
	}, []);

	useEffect(() => {
		customerDataRef.current = showInactiveCust ? customerTable.inactiveCustList : customerTable.customerList;
	}, [customerTable, showInactiveCust]);

	useEffect(() => {
		if (JString(gState.client).isValid()) {
			var axiosGetConfig = axiosDefaultConfig(gState.client);
			var axiosPut = axiosPutConfig(gState.client);
			setAxiosPutConfig(axiosPut);
			setAxiosConfig(() => (axiosGetConfig));
			loadCustomerList(axiosGetConfig);
			loadLoginList(axiosGetConfig);
			loadConfig(axiosGetConfig);
			loadCustCategoryList(axiosGetConfig);
			loadCustChainList(axiosGetConfig);
			loadCustTypeList(axiosGetConfig);
			loadBranchList(axiosGetConfig);
			loadMobileModule(axiosGetConfig);
			loadCustAreaList(axiosGetConfig);
			loadStockTemplateList(axiosGetConfig);
		}
	}, [gState.client]);

	const loadMobileModule = (config = axiosConfig) => {
		API_Service.get(req_mobile_module_setting, config).then(({ data }) => {
			const { result, extraData } = data;
			if (result) {
				const { module } = extraData;
				const _customization = module.find((content) => content.module === 'app_customization');
				if (_customization) {
					const { status } = _customization;
					setMobileCustomization(JSON.parse(status));
				}
			}
		});
	}

	const loadConfig = (axiosRequestConfig) => {
		API_Service.get(req_module_setting, axiosRequestConfig).then(({ data }) => {
			const { result, extraData } = data;
			if (result == 1) {
				const _config = getSetting(extraData, 'customer', {});
				const _customerGroups = getSetting(extraData, 'customer_groups', {});
				const _integration = getSetting(extraData, 'integration', {});
				const _modules = getSetting(extraData, 'modules', {});
				// de(_customerGroups, '--grps--', extraData)
				setConfig(_config);
				setCustomerGroups(_customerGroups);
				setIntegration(_integration);
				setModules(_modules);

				if (_modules['branch'] == true) {
					headCells.splice(2, 0, {
						name: "company",
						label: "Branch",
						options: {
							display: true,
							customBodyRender: (value) => {
								if (value) {
									const branch = JSON.parse(value);
									return branch.map((b, index) => <Chip key={index} size="small" label={b.toUpperCase()} />);
								}
								return '';
							}
						}
					});
				}
			}
		});
	}

	const loadLoginList = (axiosRequestConfig) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_salesman}${parameters}`, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData: api_Sp } = data;
				if (result) {
					var _data = [];
					for (let idx = 0; idx < api_Sp.length; idx++) {
						const { staff_code, name, login_id, company } = api_Sp[idx];
						_data.push({ staff_code, name, login_id, company: company ? company : null });
					}
					setLoginList(loginList => (_data));
				}
			}
		}).catch(err => de(err.message, 'login list'));
	}

	const loadCustomerList = (axiosRequestConfig) => {
		var parameters = '';
		if (gState.company) {
			const param = axiosURIencode({
				company: gState.company,
			});
			parameters = `?${param}`;
		}
		API_Service.get(`${req_cust}${parameters}`, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, message, extraData: apiCust } = data;
				// de(apiCust,'CUST');
				result = JString(result).toNumber();
				if (result === 1) {
					var { inactive_customer, customer, salesperson_list } = apiCust;
					var _data = [];
					var _inact_data = [];
					var indexed = {};
					var inact_indexed = {};
					const list = [];
					for (let idx = 0; idx < customer.length; idx++) {
						var obj = customer[idx];
						const {
							billing_address1,
							billing_address2,
							billing_address3,
							billing_address4,
							billing_city,
							billing_state,
							billing_zipcode,
							billing_country,
							shipping_address1,
							shipping_address2,
							shipping_address3,
							shipping_address4,
							shipping_city,
							shipping_state,
							shipping_zipcode,
							shipping_country,
							cust_code
						} = obj;
						var address = JString(billing_address1).toStr() +
							JString(billing_address2).toStr() +
							JString(billing_address3).toStr() +
							JString(billing_address4).toStr() + ' ' +
							JString(billing_city).toStr() + ' ' +
							JString(billing_state).toStr() + ' ' +
							JString(billing_zipcode).toStr() + ' ' +
							JString(billing_country).toStr();
						var shipping = JString(shipping_address1).toStr() +
							JString(shipping_address2).toStr() +
							JString(shipping_address3).toStr() +
							JString(shipping_address4).toStr() + ' ' +
							JString(shipping_city).toStr() + ' ' +
							JString(shipping_state).toStr() + ' ' +
							JString(shipping_zipcode).toStr() + ' ' +
							JString(shipping_country).toStr();

						obj.billing_address = address;
						obj.shipping_address = shipping;

						_data.push(obj);
						indexed[`${cust_code}`] = obj;
						list.push({ cust_code: cust_code, cust_company_name: obj.cust_company_name, loc: [obj.longitude, obj.latitude], marker_color: obj.marker_color });
					}
					for (let idx = 0; idx < inactive_customer.length; idx++) {
						var inact_obj = inactive_customer[idx];
						const {
							billing_address1,
							billing_address2,
							billing_address3,
							billing_address4,
							billing_city,
							billing_state,
							billing_zipcode,
							billing_country,
							shipping_address1,
							shipping_address2,
							shipping_address3,
							shipping_address4,
							shipping_city,
							shipping_state,
							shipping_zipcode,
							shipping_country,
							cust_code
						} = inact_obj;
						var inact_address = JString(billing_address1).toStr() +
							JString(billing_address2).toStr() +
							JString(billing_address3).toStr() +
							JString(billing_address4).toStr() + ' ' +
							JString(billing_city).toStr() + ' ' +
							JString(billing_state).toStr() + ' ' +
							JString(billing_zipcode).toStr() + ' ' +
							JString(billing_country).toStr();
						var inact_shipping = JString(shipping_address1).toStr() +
							JString(shipping_address2).toStr() +
							JString(shipping_address3).toStr() +
							JString(shipping_address4).toStr() + ' ' +
							JString(shipping_city).toStr() + ' ' +
							JString(shipping_state).toStr() + ' ' +
							JString(shipping_zipcode).toStr() + ' ' +
							JString(shipping_country).toStr();

						inact_obj.billing_address = inact_address;
						inact_obj.shipping_address = inact_shipping;

						_inact_data.push(inact_obj);
						inact_indexed[`${cust_code}`] = inact_obj;
						list.push({ cust_code: cust_code, cust_company_name: inact_obj.cust_company_name, loc: [inact_obj.longitude, inact_obj.latitude], marker_color: inact_obj.marker_color });
					}
					// de("loadCustomerList: I FINISHED");
					/* setCustomerIndexedList(() => (indexed));
					setInactiveCustomerIndexedList(() => (inact_indexed));
					setCustomerList(() => (_data));
					setInactiveCustList(() => (_inact_data));
					setSalespersonList(()=>(salesperson_list));
					setLatlongList(list); */
					// de("betty-customerList", _data.length);
					setCustomerTable(() => ({
						customerIndexedList: indexed,
						inactiveCustomerIndexedList: inact_indexed,
						customerList: _data,
						inactiveCustList: _inact_data,
						salespersonList: salesperson_list,
						mapLatlongList: list
					}));
					// setCustomerTable(prevState=>({...prevState, customerList: _data}));
					// de("betty-customerList2", customerTable);
				} else {
					snack(message, 'error');
				}
			}
			setCustLoaded(true);
		}).catch(err => {
			de(err.message, 'customer list');
			snack(err.message, 'error');
			setCustLoaded(true);
		});
	}

	const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

	const changeCustomerStatus = (cust_code, customer_status, cust_company_name) => {
		if (customer_status !== 1) {
			setActivateDialog({
				open: true,
				cust_code: cust_code,
				outletName: cust_company_name,
				loading: false
			});
			return;
		}

		setLoadingStatus(prev => ({ ...prev, [cust_code]: true }));
		API_Service.get(`${req_outlet_schedule_summary}?cust_code=${cust_code}`, axiosDefaultConfig(gState.client)).then(({ data }) => {
			const { result, message, extraData } = data;
			setLoadingStatus(prev => ({ ...prev, [cust_code]: false }));
			if (parseInt(result) === 1) {
				setScheduleDialog({
					open: true,
					cust_code: cust_code,
					outletName: cust_company_name,
					summary: extraData,
					loading: false
				});
			} else {
				snack(message || language.no_data, 'error');
			}
		}).catch((err) => {
			de(err.message, 'outlet sched summary');
			setLoadingStatus(prev => ({ ...prev, [cust_code]: false }));
			snack(err.message, 'error');
		});
	}

	const onConfirmInactivate = (reason) => {
		setScheduleDialog(prev => ({ ...prev, loading: true }));
		executeChangeCustomerStatus(scheduleDialog.cust_code, 1, reason);
	}

	const onConfirmActivate = (reason) => {
		setActivateDialog(prev => ({ ...prev, loading: true }));
		executeChangeCustomerStatus(activateDialog.cust_code, 0, reason);
	}

	const executeChangeCustomerStatus = (cust_code, remove_schedule, reason) => {
		var params = {
			cust_code: cust_code,
			remove_schedule: remove_schedule,
			reason: reason
		};
		params = axiosURIencode(params);
		API_Service.put(req_cust_status, params, axiosPutConfig(gState.client)).then(({ data }) => {
			var { result, message, extraData, removed_count } = data;
			if (result == 1) {
				for (let ii = 0; ii < customerTable.customerList.length; ii++) {
					const { cust_code: toFindCode } = customerTable.customerList[ii];
					if (JString(toFindCode).isEqualDeep(cust_code)) {
						customerTable.customerList[ii].customer_status = customerTable.customerList[ii].customer_status == 1 ? 0 : 1;
					}
				}
				setScheduleDialog(prev => ({ ...prev, open: false, loading: false }));
				setActivateDialog(prev => ({ ...prev, open: false, loading: false }));
				onUpdateCustomer(extraData);
				setCustomerTable(prevState => ({ ...prevState, customerList: customerTable.customerList }));
				if (remove_schedule === 1) {
					const removedCount = parseInt(removed_count || 0, 10);
					snack(`${message} (${removedCount} ${language.visits})`);
				} else {
					snack(message);
				}
			} else {
				setScheduleDialog(prev => ({ ...prev, loading: false }));
				setActivateDialog(prev => ({ ...prev, loading: false }));
				snack(message, 'error');
			}
		}).catch((err) => {
			de(err.message, 'customer status');
			setScheduleDialog(prev => ({ ...prev, loading: false }));
			setActivateDialog(prev => ({ ...prev, loading: false }));
			snack(err.message, 'error');
		});
	}

	const onUpdateCustomer = (newItem) => {
		var newcust = 1;
		if (newItem.length > 0) {
			var data = customerTable.customerList;
			var address = JString(newItem[0]['billing_address1']).toStr() +
				JString(newItem[0]['billing_address2']).toStr() +
				JString(newItem[0]['billing_address3']).toStr() +
				JString(newItem[0]['billing_address4']).toStr() +
				JString(newItem[0]['billing_city']).toStr() +
				JString(newItem[0]['billing_state']).toStr() +
				JString(newItem[0]['billing_zipcode']).toStr() +
				JString(newItem[0]['billing_country']).toStr();
			newItem[0]['billing_address'] = address;
			for (var i = 0; i < data.length; i++) {
				if (data[i]['cust_id'] === newItem[0]['cust_id']) {
					data[i] = newItem[0];
					newcust = 0;
				}
			}
			if (newcust === 1) {
				data.push(newItem[0]);
			}
			setCustomerTable(prevState => ({ ...prevState, customerList: data }));
		}
		loadCustomerList(axiosDefaultConfig(gState.client));
	}

	const custClicked = (cust_code) => {
		var cust = showInactiveCust ? _.get(customerTable.inactiveCustomerIndexedList, cust_code) : _.get(customerTable.customerIndexedList, cust_code);
		setChosenCustomer(() => (cust));
		toggleCustomerDetails(() => (true));
	}

	// CustomerTable已memo化：经ref转发，引用稳定且始终调用最新闭包
	const custClickedRef = useRef(custClicked);
	custClickedRef.current = custClicked;
	const stableCustClicked = useCallback((cust_code) => custClickedRef.current(cust_code), []);

	const headCells = useMemo(() => [
		{
			name: "cust_code",
			label: "Oulet Code",
			options: {
				display: true,
				filterType: 'textField'
			}
		},
		{
			name: "cust_company_name",
			label: "Oulet Name",
			options: {
				display: true,
				filterType: 'textField'
			}
		},
		// {
		// 	name: "company",
		// 	label: "Branch",
		// 	options: {
		// 		display: true,
		// 		customBodyRender: (value) => {
		// 			if (value) {
		// 				const branch = JSON.parse(value);
		// 				return branch.map((b, index)=><Chip key={index} size="small" label={b.toUpperCase()}/>);
		// 			}
		// 			return '';
		// 		}
		// 	}
		// },
		{
			name: "created_date",
			label: "Created Date",
			options: {
				display: true,
				filter: false,
				customBodyRender: (value) => {
					return (
						moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
					)
				}
			}
		},
		{
			name: "cust_tel",
			label: "Phone",
			options: {
				filter: false,
				display: false
			}
		},
		{
			name: "billing_address",
			label: "Address",
			options: {
				display: true,
				filterType: 'textField'
			}
		},
		{
			name: "ams",
			label: "Average Month Sales",
			options: {
				filter: true,
				display: !!gState.company && gState.company.includes("bbaruv2"),
				customBodyRender: (value) => {
					return value === 0 ? "" : JString(value).inCurrency();
				}
			}
		},
		// {
		// 	name: "shipping_address",
		// 	label: "Shipping",
		// 	options: {
		// 		display: false,
		// 		filter: false,
		// 		customBodyRender: (value) => {
		// 			return _.truncate(value, {length: 25});
		// 		}
		// 	}
		// },
		// {
		// 	name: "termcode",
		// 	label: "Term",
		// 	options: {
		// 		filter:false,
		// 		display: false
		// 	}
		// },
		{
			name: "cust_category_name",
			label: "Category",
			options: {
				display: false
			}
		},
		{
			name: "cust_chain_name",
			label: "Chain",
			options: {
				display: false
			}
		},
		{
			name: "cust_type_name",
			label: "Type",
			options: {
				display: true
			}
		},
		{
			name: "area_name",
			label: "Area",
			options: {
				display: true
			}
		},
		{
			name: "region",
			label: "Region",
			options: {
				display: false
			}
		},
		{
			name: "billing_city",
			label: language.city || "City",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "billing_state",
			label: language.state || "State",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "billing_zipcode",
			label: language.zipcode || "Zipcode",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "billing_country",
			label: language.country || "Country",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "latitude",
			label: language.latitude || "Latitude",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "longitude",
			label: language.longitude || "Longitude",
			options: {
				display: false,
				filter: false
			}
		},
		{
			name: "agent",
			label: "Agent",
			options: {
				display: true,
				filterType: 'custom',
				customBodyRender: (value) => <TruncatedCell value={value} length={25} />,
				// Agent筛选已由redefineHeaders统一接管（DataTableFilter + 逗号拆分）。下面的旧Select筛选器不再生效，
				// 且它引用customerTable.salespersonList会让headCells在客户列表到达时重建、整表多画一次，故停用
				// filterOptions: {
				// 	logic: (agent, filters) => {
				// 		//if (filters.length) return !filters.includes(agent);
				// 		if (filters.length) {
				// 			for (let i = 0; i < filters.length; i++) {
				// 				const element = filters[i];
				// 				if (agent.indexOf(element) == -1) {
				// 					return true;
				// 				}
				// 			}
				// 		}
				// 		return false;
				// 	},
				// 	display: (filterList, onChange, index, column) => {
				//
				// 		return (
				// 			<FormControl>
				// 				<InputLabel htmlFor="select-multiple-chip">
				// 					Agent
				// 				</InputLabel>
				// 				<Select
				// 					multiple
				// 					value={filterList[index]}
				// 					renderValue={selected => selected.join(", ")}
				// 					onChange={event => {
				// 						filterList[index] = event.target.value;
				// 						onChange(filterList[index], index, column);
				// 					}}
				// 				>
				//
				// 					{
				// 						customerTable.salespersonList.length > 0 ?
				// 							customerTable.salespersonList.map(item => (
				// 								<MenuItem key={item} value={item}>
				// 									<Checkbox
				// 										color="primary"
				// 										checked={filterList[index].indexOf(item) > -1}
				// 									/>
				// 									<ListItemText primary={item} />
				// 								</MenuItem>
				// 							)) : null
				// 					}
				// 				</Select>
				// 			</FormControl>
				// 		);
				// 	}
				// }
			}
		},
		// {
		// 	name: "current_balance",
		// 	label: "Outstanding",
		// 	options: {
		// 		display: false,
		// 		filter: false,
		// 		customBodyRender: (value) => {
		// 			return JString(value).inCurrency();
		// 		}
		// 	}
		// },
		{
			name: "updated_at",
			label: "Last Updated",
			options: {
				display: true,
				filter: false,
				customBodyRender: (value) => {
					return (
						moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')
					)
				}
			}
		},
		{
			name: "created_by",
			label: "Created By",
			options: {
				filter: false,
				display: false
			}
		},
		{
			name: "updated_by",
			label: "Last Updated By",
			options: {
				filter: false,
				display: true
			}
		},
		{
			name: "tmplt_data",
			label: "Template",
			options: {
				display: true,
				filter: false,
				customBodyRender: (value) => {
					if (value && value.length > 0) {
						return (
							<>
								{
									value.map((data) => {
										if (data.tmplt_id) {
											return (<Chip key={String(data.tmplt_id).concat("---template--chip")} size="small" style={{ backgroundColor: "grey" }} label={data.tmplt_name} />)
										}
									})
								}
							</>
						);
					} else {
						return ("-");
					}
				}
			}
		},
		{
			name: "customer_status",
			label: "Status",
			options: {
				display: true,
				sort: false,
				filter: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowData } = tableMeta;
					const cust_code = rowData[0];
					const cust_company_name = rowData[1];
					var customerStatus = parseInt(value);

					const onChangeStatus = (e) => {
						e.stopPropagation();
						changeCustomerStatus(cust_code, customerStatus, cust_company_name);
					}

					if (loadingStatus[cust_code]) {
						return <CircularProgress size={40} />;
					}

					if (customerStatus === 1) {
						return (
							<IconButton onClick={onChangeStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else if (customerStatus === 0) {
						return (
							<IconButton onClick={onChangeStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				}
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	], [language, gState.company]);

	// 列显示偏好：进页面应用用户上次的显示列，切换时存后端（与其它表一致，page_key=Customer）
	const { columns: preferredColumns, onColumnViewChange: onPrefColumnViewChange } = useColumnPreference('Customer', headCells, gState.client);
	const [columnViewVersion, setColumnViewVersion] = useState(0);

	// 切换列显示：只存后端。不重建columns（重建会让MUIDataTable整表重算），Filter弹窗按实时列状态自行判断
	const onColumnViewChange = useCallback((changedColumn, action) => {
		onPrefColumnViewChange(changedColumn, action);
	}, [onPrefColumnViewChange]);

	// 偏好加载完成或切换列后重建tableHeader
	useEffect(() => {
		if (preferredColumns.length > 0) {
			setTableHeader(redefineHeaders(preferredColumns));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [preferredColumns, columnViewVersion]);

	// loadingStatus变化时重建，让Status列的转圈随锁定/解锁刷新
	useEffect(() => {
		setColumnViewVersion(version => version + 1);
	}, [loadingStatus]);

	const categoryHeadCell = [
		{
			name: "cust_category_id",
			label: "--",
			options: {
				display: false
			}
		},
		{
			name: "cust_category_code",
			label: "Code",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '20%', minWidth: '150px' } }),
				setCellHeaderProps: () => ({ style: { width: '20%', minWidth: '150px' } })
			}
		},
		{
			name: "cust_category_name",
			label: "Name",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '50%', minWidth: '250px' } }),
				setCellHeaderProps: () => ({ style: { width: '50%', minWidth: '250px' } })
			}
		},
		{
			name: "cust_category_status",
			label: "Status",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				customBodyRender: (value) => {
					switch (value) {
						case "1":
							return (
								<Chip
									size="small"
									icon={<DoneIcon />}
									label="Active"
									color="primary"
								/>
							);
						case "0":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						case "2":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						default:
							return (null);
					}
				}
			}
		},
		{
			name: "cust_category_status_action",
			label: "Action",
			options: {
				display: true,
				filter: false,
				sort: false,
				empty: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				customBodyRender: (value, tableMeta) => {
					const { rowIndex: dataIndex, rowData } = tableMeta;
					const status = rowData[3];
					const code = rowData[1];

					const onChangeCustCatStatus = (e) => {
						e.stopPropagation();
						const currentList = showInactiveCustCategory ? inactiveCustCategoryList : activeCustCategoryList;
						changeCustCatStatus(currentList[dataIndex]['cust_category_code'], (isUpdated) => {
						});
					}

					if (loadingStatus[code]) {
						return <CircularProgress size={40} />;
					}

					if (status == 1) {
						return (
							<IconButton onClick={onChangeCustCatStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else {
						return (
							<IconButton onClick={onChangeCustCatStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				}
			}
		}
	];

	const chainHeadCell = [
		{
			name: "cust_chain_id",
			label: "--",
			options: {
				display: false
			}
		},
		{
			name: "cust_chain_code",
			label: "Code",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '20%', minWidth: '150px' } }),
				setCellHeaderProps: () => ({ style: { width: '20%', minWidth: '150px' } })
			}
		},
		{
			name: "cust_chain_name",
			label: "Name",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '50%', minWidth: '250px' } }),
				setCellHeaderProps: () => ({ style: { width: '50%', minWidth: '250px' } })
			}
		},
		{
			name: "cust_chain_status",
			label: "Status",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				customBodyRender: (value) => {
					switch (value) {
						case "1":
							return (
								<Chip
									size="small"
									icon={<DoneIcon />}
									label="Active"
									color="primary"
								/>
							);
						case "0":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						case "2":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						default:
							return (null);
					}
				}
			}
		},
		{
			name: "cust_chain_status_action",
			label: "Action",
			options: {
				display: true,
				filter: false,
				sort: false,
				empty: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				customBodyRender: (value, tableMeta) => {
					const { rowIndex: dataIndex, rowData } = tableMeta;
					const status = rowData[3];
					const code = rowData[1];

					const onChangeCustChainStatus = (e) => {
						e.stopPropagation();
						const currentList = showInactiveCustChain ? inactiveCustChainList : activeCustChainList;
						changeCustChainStatus(currentList[dataIndex]['cust_chain_code'], (isUpdated) => {
						});
					}

					if (loadingStatus[code]) {
						return <CircularProgress size={40} />;
					}

					if (status == 1) {
						return (
							<IconButton onClick={onChangeCustChainStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else {
						return (
							<IconButton onClick={onChangeCustChainStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				}
			}
		}
	];

	const customerAreaCell = [
		{
			name: "id",
			label: "--",
			options: {
				display: false
			}
		},
		{
			name: "area_code",
			label: "Code",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '20%', minWidth: '150px' } }),
				setCellHeaderProps: () => ({ style: { width: '20%', minWidth: '150px' } })
			}
		},
		{
			name: "area_name",
			label: "Name",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '50%', minWidth: '250px' } }),
				setCellHeaderProps: () => ({ style: { width: '50%', minWidth: '250px' } })
			}
		},
		{
			name: "area_status",
			label: "Status",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				customBodyRender: (value) => {
					switch (value) {
						case "1":
							return (
								<Chip
									size="small"
									icon={<DoneIcon />}
									label="Active"
									color="primary"
								/>
							);
						case "0":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						case "2":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						default:
							return (null);
					}
				}
			}
		},
		{
			name: "area_status_action",
			label: "Action",
			options: {
				display: true,
				filter: false,
				sort: false,
				empty: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				customBodyRender: (value, tableMeta) => {
					const { rowIndex: dataIndex, rowData } = tableMeta;
					const status = rowData[3];
					const code = rowData[1];

					const onChangeCustAreaStatus = (e) => {
						e.stopPropagation();
						const currentList = showInactiveCustArea ? inactiveCustAreaList : activeCustAreaList;
						changeCustAreaStatus(currentList[dataIndex]['area_code'], (isUpdated) => {
						});
					}

					if (loadingStatus[code]) {
						return <CircularProgress size={40} />;
					}

					if (status == 1) {
						return (
							<IconButton onClick={onChangeCustAreaStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else {
						return (
							<IconButton onClick={onChangeCustAreaStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				}
			}
		}
	];

	const typeHeadCell = [
		{
			name: "id",
			label: "--",
			options: {
				display: false
			}
		},
		{
			name: "code",
			label: "Code",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '20%', minWidth: '150px' } }),
				setCellHeaderProps: () => ({ style: { width: '20%', minWidth: '150px' } })
			}
		},
		{
			name: "name",
			label: "Name",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '50%', minWidth: '250px' } }),
				setCellHeaderProps: () => ({ style: { width: '50%', minWidth: '250px' } })
			}
		},
		// {
		//     name: "created_at",
		//     label: "Created Date",
		//     options: {
		//         display: true
		//     }
		// },
		// {
		//     name: "updated_at",
		//     label: "Updated Date",
		//     options: {
		//         display: true
		//     }
		// },
		{
			name: "status",
			label: "Status",
			options: {
				display: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '100px' } }),
				customBodyRender: (value) => {
					switch (value) {
						case "1":
							return (
								<Chip
									size="small"
									icon={<DoneIcon />}
									label="Active"
									color="primary"
								/>
							);
						case "0":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						case "2":
							return (
								<Chip
									size="small"
									icon={<CloseIcon />}
									label="Inactive"
									style={{ backgroundColor: grey[400], color: '#fff' }}
								/>
							);
						default:
							return (null);
					}
				}
			}
		},
		{
			name: "status_action",
			label: "Action",
			options: {
				display: true,
				filter: false,
				sort: false,
				empty: true,
				setCellProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				setCellHeaderProps: () => ({ style: { width: '15%', minWidth: '80px' } }),
				customBodyRender: (value, tableMeta) => {
					const { rowIndex: dataIndex, rowData } = tableMeta;
					const status = rowData[3];
					const code = rowData[1];

					const onChangeCustTypeStatus = (e) => {
						e.stopPropagation();
						const currentList = showInactiveCustType ? inactiveCustTypeList : activeCustTypeList;
						changeCustTypeStatus(currentList[dataIndex]['code'], (isUpdated) => {
						});
					}

					if (loadingStatus[code]) {
						return <CircularProgress size={40} />;
					}

					if (status == 1) {
						return (
							<IconButton onClick={onChangeCustTypeStatus}>
								<LockOpenIcon />
							</IconButton>
						);
					} else {
						return (
							<IconButton onClick={onChangeCustTypeStatus}>
								<LockIcon htmlColor={red[500]} />
							</IconButton>
						);
					}
				}
			}
		}
	];

	const changeCustCatStatus = (cust_category_code, cb) => {
		const isActive = activeCustCategoryList.some(item => item.cust_category_code == cust_category_code);
		if (isActive) {
			setLoadingStatus(prev => ({ ...prev, [cust_category_code]: true }));
			API_Service.get(req_check_outlet_management_status + '?type=category&code=' + cust_category_code, axiosConfig).then(({ data }) => {
				var { result } = data;
				if (result == 1) {
					setLoadingStatus(prev => ({ ...prev, [cust_category_code]: false }));
					setConfirmDialog({
						open: true,
						title: language.confirmation || 'Confirmation',
						content: language.category_in_use_confirm || 'There are still outlets under this Category If you click "CONFIRM", all outlets under this Category will be cleared automatically and this Category will be set to "Inactive". Do you want to continue?',
						onConfirm: () => {
							executeChangeCustCatStatus(cust_category_code, cb);
							setConfirmDialog(prev => ({ ...prev, open: false }));
						}
					});
				} else {
					executeChangeCustCatStatus(cust_category_code, cb);
				}
			}).catch((err) => {
				setLoadingStatus(prev => ({ ...prev, [cust_category_code]: false }));
			});
			return;
		}
		executeChangeCustCatStatus(cust_category_code, cb);
	}

	const executeChangeCustCatStatus = (cust_category_code, cb) => {
		setLoadingStatus(prev => ({ ...prev, [cust_category_code]: true }));
		var params = {
			cust_category_code: cust_category_code,
			client: gState.client,
			updated_by: gState.username
		};
		params = axiosURIencode(params);
		API_Service.put(req_cust_category_status, params, axiosConfig).then(({ data }) => {
			var { result } = data;
			if (result == 1) {
				onUpdateCustCategory();
				toggleCustChainDetails(() => (false));
				enqueueSnackbar("Status updated successfully", { variant: 'success' });
			} else {
				enqueueSnackbar("Failed to update status", { variant: 'error' });
			}
			setLoadingStatus(prev => ({ ...prev, [cust_category_code]: false }));
			cb(result == 1);
		}).catch((err) => {
			de(err.message);
			setLoadingStatus(prev => ({ ...prev, [cust_category_code]: false }));
			enqueueSnackbar(err.message, { variant: 'error' });
		});
	}

	const changeCustChainStatus = (cust_chain_code, cb) => {
		const isActive = activeCustChainList.some(item => item.cust_chain_code == cust_chain_code);
		if (isActive) {
			setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: true }));
			API_Service.get(req_check_outlet_management_status + '?type=chain&code=' + cust_chain_code, axiosConfig).then(({ data }) => {
				var { result } = data;
				if (result == 1) {
					setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: false }));
					setConfirmDialog({
						open: true,
						title: language.confirmation || 'Confirmation',
						content: language.chain_in_use_confirm || 'There are still outlets under this Chain If you click "CONFIRM", all outlets under this Chain will be cleared automatically and this Chain will be set to "Inactive". Do you want to continue?',
						onConfirm: () => {
							executeChangeCustChainStatus(cust_chain_code, cb);
							setConfirmDialog(prev => ({ ...prev, open: false }));
						}
					});
				} else {
					executeChangeCustChainStatus(cust_chain_code, cb);
				}
			}).catch((err) => {
				setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: false }));
			});
			return;
		}
		executeChangeCustChainStatus(cust_chain_code, cb);
	}

	const executeChangeCustChainStatus = (cust_chain_code, cb) => {
		setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: true }));
		var params = {
			cust_chain_code: cust_chain_code,
			client: gState.client,
			updated_by: gState.username
		};
		params = axiosURIencode(params);
		API_Service.put(req_cust_chain_status, params, axiosConfig).then(({ data }) => {
			var { result } = data;
			if (result == 1) {
				onUpdateCustChain();
				enqueueSnackbar("Status updated successfully", { variant: 'success' });
			} else {
				enqueueSnackbar("Failed to update status", { variant: 'error' });
			}
			setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: false }));
			cb(result == 1);
		}).catch((err) => {
			de(err.message);
			setLoadingStatus(prev => ({ ...prev, [cust_chain_code]: false }));
			enqueueSnackbar(err.message, { variant: 'error' });
		});
	}

	const changeCustAreaStatus = (area_code, cb) => {
		const isActive = activeCustAreaList.some(item => item.area_code == area_code);
		if (isActive) {
			setLoadingStatus(prev => ({ ...prev, [area_code]: true }));
			API_Service.get(req_check_outlet_management_status + '?type=area&code=' + area_code, axiosConfig).then(({ data }) => {
				var { result } = data;
				if (result == 1) {
					setLoadingStatus(prev => ({ ...prev, [area_code]: false }));
					setConfirmDialog({
						open: true,
						title: language.confirmation || 'Confirmation',
						content: language.area_in_use_confirm || 'There are still outlets under this Area If you click "CONFIRM", all outlets under this Area will be cleared automatically and this Area will be set to "Inactive". Do you want to continue?',
						onConfirm: () => {
							executeChangeCustAreaStatus(area_code, cb);
							setConfirmDialog(prev => ({ ...prev, open: false }));
						}
					});
				} else {
					executeChangeCustAreaStatus(area_code, cb);
				}
			}).catch((err) => {
				setLoadingStatus(prev => ({ ...prev, [area_code]: false }));
			});
			return;
		}
		executeChangeCustAreaStatus(area_code, cb);
	}

	const executeChangeCustAreaStatus = (area_code, cb) => {
		setLoadingStatus(prev => ({ ...prev, [area_code]: true }));
		var params = {
			area_code: area_code,
			client: gState.client,
			updated_by: gState.username
		};
		params = axiosURIencode(params);
		API_Service.put(req_cust_area_status, params, axiosConfig).then(({ data }) => {
			var { result } = data;
			if (result == 1) {
				onUpdateCustArea();
				enqueueSnackbar("Status updated successfully", { variant: 'success' });
			} else {
				enqueueSnackbar("Failed to update status", { variant: 'error' });
			}
			setLoadingStatus(prev => ({ ...prev, [area_code]: false }));
			cb(result == 1);
		}).catch((err) => {
			de(err.message);
			setLoadingStatus(prev => ({ ...prev, [area_code]: false }));
			enqueueSnackbar(err.message, { variant: 'error' });
		});
	}

	const changeCustTypeStatus = (cust_type_code, cb) => {
		const isActive = activeCustTypeList.some(item => item.code == cust_type_code);
		if (isActive) {
			setLoadingStatus(prev => ({ ...prev, [cust_type_code]: true }));
			API_Service.get(req_check_outlet_management_status + '?type=type&code=' + cust_type_code, axiosConfig).then(({ data }) => {
				var { result } = data;
				if (result == 1) {
					setLoadingStatus(prev => ({ ...prev, [cust_type_code]: false }));
					setConfirmDialog({
						open: true,
						title: language.confirmation || 'Confirmation',
						content: language.type_in_use_confirm || 'There are still outlets under this Type If you click "CONFIRM", all outlets under this Type will be cleared automatically and this Type will be set to "Inactive". Do you want to continue?',
						onConfirm: () => {
							executeChangeCustTypeStatus(cust_type_code, cb);
							setConfirmDialog(prev => ({ ...prev, open: false }));
						}
					});
				} else {
					executeChangeCustTypeStatus(cust_type_code, cb);
				}
			}).catch((err) => {
				setLoadingStatus(prev => ({ ...prev, [cust_type_code]: false }));
			});
			return;
		}
		executeChangeCustTypeStatus(cust_type_code, cb);
	}

	const executeChangeCustTypeStatus = (cust_type_code, cb) => {
		setLoadingStatus(prev => ({ ...prev, [cust_type_code]: true }));
		var params = {
			cust_type_code: cust_type_code,
			client: gState.client,
			updated_by: gState.username
		};
		params = axiosURIencode(params);
		API_Service.put(req_cust_type_status, params, axiosConfig).then(({ data }) => {
			var { result } = data;
			if (result == 1) {
				onUpdateCustType();
				enqueueSnackbar("Status updated successfully", { variant: 'success' });
			} else {
				enqueueSnackbar("Failed to update status", { variant: 'error' });
			}
			setLoadingStatus(prev => ({ ...prev, [cust_type_code]: false }));
			cb(result == 1);
		}).catch((err) => {
			de(err.message);
			setLoadingStatus(prev => ({ ...prev, [cust_type_code]: false }));
			enqueueSnackbar(err.message, { variant: 'error' });
		});
	}

	const onClickCustCategoryList = (item_code, arr) => {
		for (let index = 0; index < arr.length; index++) {
			const { cust_category_code } = arr[index];
			if (item_code == cust_category_code) {
				onClickCustCategory(index);
			}
		}
	}

	const onClickCustChainList = (item_code, arr) => {
		for (let index = 0; index < arr.length; index++) {
			const { cust_chain_code } = arr[index];
			if (item_code == cust_chain_code) {
				onClickCustChain(index);
			}
		}
	}

	const onClickCustTypeList = (item) => {
		toggleCustTypeDetails(true);
		setChoosenCustType(item);
		// de("betty", item);
		// for (let index = 0; index < arr.length; index++) {
		// 	const {code} = arr[index];
		// 	if (item_code == code) {
		// 		onClickCustType(index);
		// 	}
		// }
	}

	const onClickCustAreaList = (item) => {
		toggleCustAreaDetails(true);
		setChoosenCustArea(item);
	}

	const onClickCustCategory = (index) => {
		setChosenCustCategory(() => (index));
		toggleCustCategoryDetails(() => (true));
	}

	const onClickCustChain = (index) => {
		setChosenCustChain(() => (index));
		toggleCustChainDetails(() => (true));
	}

	const onUpdateCustCategory = () => {
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		loadCustCategoryList(axiosGetConfig);
	}

	const onUpdateCustChain = () => {
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		loadCustChainList(axiosGetConfig);
	}

	const onUpdateCustType = () => {
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		loadCustTypeList(axiosGetConfig);
	}

	const onUpdateCustArea = () => {
		var axiosGetConfig = axiosDefaultConfig(gState.client);
		loadCustAreaList(axiosGetConfig);
	}

	const loadCustCategoryList = (axiosRequestConfig) => {
		API_Service.get(`${req_cust_category}`, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;

				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if (element['cust_category_status'] == 1) {
							_act_data.push(element);
						} else {
							_inact_data.push(element);
						}
					}
					setCustomerCategoryList(() => (extraData));
					setActiveCustCategoryList(() => (_act_data));
					setInactiveCustCategoryList(() => (_inact_data));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
	}

	const loadCustChainList = (axiosRequestConfig) => {
		API_Service.get(`${req_cust_chain}`, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if (element['cust_chain_status'] == 1) {
							_act_data.push(element);
						} else {
							_inact_data.push(element);
						}
					}
					setCustomerChainList(() => (extraData));
					setActiveCustChainList(() => (_act_data));
					setInactiveCustChainList(() => (_inact_data));
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}

	const loadCustTypeList = (axiosRequestConfig) => {
		API_Service.get(req_cust_type, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if (JString(element['status']).toNumber() === 1) {
							_act_data.push(element);
						} else {
							_inact_data.push(element);
						}
					}
					setCustomerTypeList(() => (extraData));
					setActiveCustTypeList(() => (_act_data));
					setInactiveCustTypeList(() => (_inact_data));
				}
			}
		}).catch(err => de(err.message, 'customer chain list'));
	}

	const loadCustAreaList = (axiosRequestConfig) => {
		API_Service.get(req_cust_area, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					var _inact_data = [];
					var _act_data = [];
					for (let i = 0; i < extraData.length; i++) {
						const element = extraData[i];
						if (JString(element['area_status']).toNumber() === 1) {
							_act_data.push(element);
						} else {
							_inact_data.push(element);
						}
					}
					setCustomerAreaList(() => (extraData));
					setActiveCustAreaList(() => (_act_data));
					setInactiveCustAreaList(() => (_inact_data));
				}
			}
		}).catch(err => de(err.message, 'customer area list'));
	}

	const loadBranchList = (axiosRequestConfig) => {
		API_Service.get(req_cust_branches, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				var _data = [];
				if (result === 1) {
					for (let i = 0; i < extraData.length; i++) {
						if (gState.company) {
							const company = JSON.parse(gState.company);
							if (company.includes(extraData[i]['value'])) {
								_data.push(extraData[i]);
							}
						} else {
							_data.push(extraData[i]);
						}
					}
					setBranchesList(_data);
				}
			}
		}).catch(err => de(err.message, 'customer branch list'));
	}

	const loadStockTemplateList = (axiosRequestConfig) => {
		API_Service.get(`${req_stocktemplate}?active_status=1`, axiosRequestConfig).then(({ data }) => {
			if (data) {
				var { result, extraData } = data;
				result = JString(result).toNumber();
				if (result === 1) {
					setStockTemplateList(extraData);
				}
			}
		});
	}

	const chosenCustCategoryData = customerCategoryList[chosenCustCategory];
	// const chosenCustChainData = customerChainList[chosenCustChain];
	const chosenCustChainData = showInactiveCustChain ? inactiveCustChainList[chosenCustChain] : activeCustChainList[chosenCustChain];

	return (
		<div>
			{
				currentPage === 0 && (
					<div className={classes.marginTop}>
						{
							(!custLoaded) ?
								<ShimmerLoading
									blocks={[
										{ count: 1, height: 50 },
										{ count: 1, height: 40 },
										{ count: 1, height: 30 },
										{ count: 1, height: 20 },
										{ count: 1, height: 40 },
										{ count: 1, height: 50 }
									]}
								/> :
								<CustomerTable
									inactiveCustList={customerTable.inactiveCustList}
									customerList={customerTable.customerList}
									custClicked={stableCustClicked}
									showCreateDialog={showCreateDialog}
									headCells={tableHeader}
									setShowInactive={setShowInactiveCust}
									showInactive={showInactiveCust}
									integration={integration}
									onColumnViewChange={onColumnViewChange}
									onFilterChange={onCustomerFilterChange}
								/>
						}
					</div>
				)
			}
			{
				currentPage === 1 && (
					<div className={classes.marginTop}>
						<Tabs
							indicatorColor={'primary'}
							textColor={'inherit'}
							variant={'fullWidth'}
							value={tabPosition}
							centered
							onChange={(e, v) => setTabPosition(v)}
							aria-label="simple tabs log">
							<Tab label={language.cust_category} />
							<Tab label={language.cust_type} />
							<Tab label={language.cust_chain} />
							<Tab label={language.cust_area} />
						</Tabs>
						<div style={{ height: 15 }} />
						{
							tabPosition === 0 && (
								<>
									<MUIDataTable
										title={language.cust_category_list}
										data={showInactiveCustCategory ? inactiveCustCategoryList : activeCustCategoryList}
										columns={categoryHeadCell}
										options={{
											print: false,
											filter: true,
											download: false,
											selectableRows: 'none',
											rowsPerPage: 99,
											rowsPerPageOptions: [125, 140, 165, 200],
											responsive: 'simple',
											onRowClick: (rowData, { dataIndex }) => {
												const currentList = showInactiveCustCategory ? inactiveCustCategoryList : activeCustCategoryList;
												onClickCustCategoryList(currentList[dataIndex]['cust_category_code'], customerCategoryList)
											},
											customToolbar: () =>
												<TemplateTableToolbar
													addNewItem={() => {
														setNewCustCategoryView(true)
													}}
													showActive={!showInactiveCustCategory}
													onShowInactive={setShowInactiveCustCategory}
												/>
										}}
									/>
								</>
							)
						}
						{
							tabPosition === 1 && (
								<MUIDataTable
									title={language.cust_type_list}
									data={showInactiveCustType ? inactiveCustTypeList : activeCustTypeList}
									columns={typeHeadCell}
									options={{
										print: false,
										filter: true,
										download: false,
										selectableRows: 'none',
										rowsPerPage: 99,
										rowsPerPageOptions: [125, 140, 165, 200],
										responsive: 'simple',
										onRowClick: (rowData, { dataIndex }) => {
											const currentList = showInactiveCustType ? inactiveCustTypeList : activeCustTypeList;
											onClickCustTypeList(currentList[dataIndex])
										},
										customToolbar: () =>
											<TemplateTableToolbar
												addNewItem={() => {
													setNewCustTypeView(true)
												}}
												showActive={!showInactiveCustType}
												onShowInactive={setShowInactiveCustType}
											/>
									}}
								/>
							)
						}
						{
							tabPosition === 2 && (
								<MUIDataTable
									title={language.cust_chain_list}
									data={showInactiveCustChain ? inactiveCustChainList : activeCustChainList}
									columns={chainHeadCell}
									options={{
										print: false,
										filter: true,
										download: false,
										selectableRows: 'none',
										rowsPerPage: 99,
										rowsPerPageOptions: [125, 140, 165, 200],
										responsive: 'simple',
										onRowClick: (rowData, { dataIndex }) => {
											const currentList = showInactiveCustChain ? inactiveCustChainList : activeCustChainList;
											onClickCustChainList(currentList[dataIndex]['cust_chain_code'], currentList)
										},
										customToolbar: () =>
											<TemplateTableToolbar
												addNewItem={() => {
													setNewCustChainView(true)
												}}
												showActive={!showInactiveCustChain}
												onShowInactive={setShowInactiveCustChain}
											/>
									}}
								/>
							)
						}
						{
							tabPosition === 3 && (
								<MUIDataTable
									title={language.area}
									data={showInactiveCustArea ? inactiveCustAreaList : activeCustAreaList}
									columns={customerAreaCell}
									options={{
										print: false,
										filter: true,
										download: false,
										selectableRows: 'none',
										rowsPerPage: 99,
										rowsPerPageOptions: [125, 140, 165, 200],
										responsive: 'simple',
										onRowClick: (rowData, { dataIndex }) => {
											const currentList = showInactiveCustArea ? inactiveCustAreaList : activeCustAreaList;
											onClickCustAreaList(currentList[dataIndex])
										},
										customToolbar: () =>
											<TemplateTableToolbar
												addNewItem={() => {
													setNewCustAreaView(true)
												}}
												showActive={!showInactiveCustArea}
												onShowInactive={setShowInactiveCustArea}
											/>
									}}
								/>
							)
						}
					</div>
				)
			}
			{
				currentPage === 2 && (
					<>
						<GoogleMap
						// lightTheme={lightTheme}
						// latlongList={latlongList}
						// height={'100%'}
						// width={'100%'}
						// mapHeight={'80vh'}
						// pointerEvents={"none"}
						/>
					</>
				)
			}
			{
				currentPage === 3 && (
					<BulkImport
						language={language}
					/>
				)
			}
			<BottomNavigation
				value={currentPage}
				onChange={(event, newValue) => {
					setCurrentPage(newValue);
				}}
				styles={{
					width: '100%',
					position: 'fixed',
					bottom: 0
				}}
				showLabels
				className={commonStyles.bottomNav}>
				<BottomNavigationAction label="Outlet List" icon={<CreateNewFolderIcon />} />
				<BottomNavigationAction label="Management" icon={<AccountTreeIcon />} />
				<BottomNavigationAction label="Map" icon={<MapIcon />} />
				<BottomNavigationAction label="Bulk Import" icon={<ImportExportIcon />} />
				{/* <BottomNavigationAction label="Promo / Bundle" icon={<RedeemIcon />} /> */}
			</BottomNavigation>
			<CustomerDetails
				open={showCustomerDetails}
				setClose={() => toggleCustomerDetails(() => (false))}
				customer={chosenCustomer}
				language={language}
				axiosConfig={axiosConfig}
				axiosPut={axiosPut}
				onSnack={({ msg, type }) => {
					snack(msg, type);
				}}
				availableAgents={loginList}
				config={config}
				groups={customerGroups}
				onUpdateCustomer={onUpdateCustomer}
				integration={integration}
				custCategoryList={activeCustCategoryList}
				custChainList={activeCustChainList}
				custTypeList={activeCustTypeList}
				custAreaList={activeCustAreaList}
				branchesList={branchesList}
				company={gState.company}
			/>
			{
				createDialog && (
					<AddCustomer
						open={createDialog}
						onClose={(data) => {
							showCreateDialog(false);
							onUpdateCustomer(data);
						}}
						language={language}
						custCategoryList={activeCustCategoryList}
						custChainList={activeCustChainList}
						custTypeList={activeCustTypeList}
						custAreaList={activeCustAreaList}
						branchesList={branchesList}
						stockTemplateList={stockTemplateList}
					/>
				)
			}
			{
				newCustCategoryView && (
					<AddCustCategory
						open={newCustCategoryView}
						onClose={(data) => {
							setNewCustCategoryView(false);
							onUpdateCustCategory(data);
						}}
						language={language}
						onSnack={(msg, type) => snack(msg, type)}
						axiosConfig={axiosConfig}
						customization={mobileCustomization}
					/>
				)
			}

			{newCustChainView && (
				<AddCustChain
					open={newCustChainView}
					onClose={(data) => {
						setNewCustChainView(false);
						onUpdateCustChain(data);
					}}
					language={language}
					onSnack={(msg, type) => snack(msg, type)}
					axiosConfig={axiosConfig}
				/>
			)}

			{
				newCustTypeView && (
					<AddCustType
						open={newCustTypeView}
						onClose={(data) => {
							setNewCustTypeView(false);
							onUpdateCustType(data);
						}}
						language={language}
						onSnack={(msg, type) => snack(msg, type)}
						axiosConfig={axiosConfig}
					/>
				)
			}
			{
				newCustAreaView && (
					<AddAreaType
						open={newCustAreaView}
						onClose={(data) => {
							setNewCustAreaView(false);
							onUpdateCustArea(data);
						}}
						language={language}
						onSnack={(msg, type) => snack(msg, type)}
						axiosConfig={axiosConfig}
					/>
				)
			}
			{
				showCustCategoryDetails ?
					<CustCategoryDetails
						open={showCustCategoryDetails}
						setClose={() => {
							setChosenCustCategory(() => (-1));
							toggleCustCategoryDetails(() => (false));
						}}
						item={showCustCategoryDetails ? chosenCustCategoryData : null}
						language={language}
						onUpdateCustCategory={() => {
							onUpdateCustCategory()
						}}
						onSnack={(msg, type) => snack(msg, type)}
						integration={integration}
						mobileCustomization={mobileCustomization}
						modules={modules}
					/> : null
			}
			{
				showCustChainDetails ?
					<CustChainDetails
						open={showCustChainDetails}
						setClose={() => {
							setChosenCustChain(() => (-1));
							toggleCustChainDetails(() => (false));
						}}
						item={showCustChainDetails ? chosenCustChainData : null}
						language={language}
						onUpdateCustChain={() => {
							onUpdateCustChain()
						}}
						onSnack={(msg, type) => snack(msg, type)}
						integration={integration}
					/> : null
			}
			{
				showCustTypeDetails ?
					<CustTypeDetails
						open={showCustTypeDetails}
						setClose={() => {
							setChoosenCustType(() => ({}));
							toggleCustTypeDetails(() => (false));
						}}
						item={showCustTypeDetails ? choosenCustType : null}
						language={language}
						onUpdateCustType={() => {
							onUpdateCustType()
						}}
						onSnack={(msg, type) => snack(msg, type)}
						integration={integration}
					/> : null
			}
			{
				showCustAreaDetails ?
					<CustAreaDetails
						open={showCustAreaDetails}
						setClose={() => {
							setChoosenCustArea(() => ({}));
							toggleCustAreaDetails(() => (false));
						}}
						item={showCustAreaDetails ? choosenCustArea : null}
						language={language}
						onUpdateCustArea={() => {
							onUpdateCustArea()
						}}
						onSnack={(msg, type) => snack(msg, type)}
						integration={integration}
					/> : null
			}
			<Dialog
				open={confirmDialog.open}
				onClose={() => setConfirmDialog(prev => ({ ...prev, open: false }))}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{confirmDialog.title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{confirmDialog.content}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setConfirmDialog(prev => ({ ...prev, open: false }))} color="primary">
						{language.cancel || "Cancel"}
					</Button>
					<Button onClick={() => {
						if (confirmDialog.onConfirm) confirmDialog.onConfirm();
					}} color="primary" autoFocus>
						{language.confirm || "Confirm"}
					</Button>
				</DialogActions>
			</Dialog>
			<OutletInactivateDialog
				open={scheduleDialog.open}
				outletName={scheduleDialog.outletName}
				summary={scheduleDialog.summary}
				loading={scheduleDialog.loading}
				onCancel={() => {
					if (scheduleDialog.loading) return;
					setScheduleDialog(prev => ({ ...prev, open: false }));
				}}
				onConfirm={(reason) => onConfirmInactivate(reason)}
			/>
			<OutletActivateDialog
				open={activateDialog.open}
				outletName={activateDialog.outletName}
				loading={activateDialog.loading}
				onCancel={() => {
					if (activateDialog.loading) return;
					setActivateDialog(prev => ({ ...prev, open: false }));
				}}
				onConfirm={(reason) => onConfirmActivate(reason)}
			/>
		</div>
	)
}

// memo化：父页其他API回包（分类/连锁/模板等）不再触发整表重画；所有函数props须引用稳定
const CustomerTable = React.memo(function CustomerTable({
	inactiveCustList,
	customerList,
	custClicked,
	showCreateDialog,
	headCells,
	setShowInactive,
	showInactive,
	integration,
	onColumnViewChange,
	onFilterChange
}) {
	const [queryChanged, queryChanging] = useState(false);
	const [gState] = useContext(AppContext);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const singleton = PersistantData.getInstance();
	var { translation: language } = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}
	const theme = useTheme();
	const filterTheme = useMemo(() => createDataTableFilterTheme(theme), [theme]);

	useEffect(() => {
	}, [customerList]);

	// Do NOT early-return on empty list — hides the toolbar + "Add New" button,
	// leaving a blank screen with no way to create the first outlet.
	// MUIDataTable renders an empty body ("no records") and keeps the toolbar.
	// if (customerList.length == 0 && inactiveCustList.length == 0) {
	// 	return null;
	// }
	return (
		<MuiThemeProvider theme={filterTheme}>
			<MUIDataTable
				title={language.customer_low}
				data={showInactive ? inactiveCustList : customerList}
				columns={headCells}
				options={{
					selectableRows: 'none',
					print: false,
					filter: true,
					textLabels: {
						filter: {
							title: language.filter_table,
							reset: language.reset,
							all: language.all
						},
						toolbar: {
							filterTable: language.filter_table
						}
					},
					onColumnViewChange: (changedColumn, action) => {
						if (onColumnViewChange) {
							onColumnViewChange(changedColumn, action);
						}
					},
					onFilterChange: (changedColumn, filterList) => {
						if (onFilterChange) {
							onFilterChange(changedColumn, filterList);
						}
					},
					download: true,
					// 150行一次画完卡约0.7秒，降到50行（2026-10-19）
					// rowsPerPage: 150,
					// rowsPerPageOptions: [150, 300, 600, 900],
					rowsPerPage: 50,
					rowsPerPageOptions: [50, 150, 300, 600, 900],
					responsive: 'simple',
					setTableProps: () => ({ size: 'small' }),
					// customSearch: (searchQuery, currentRow, columns)=>{
					// 	de("Betty-customSearch", searchQuery, currentRow, columns);
					// 	for (let i = 0; i < columns.length; i++)
					// 	{
					// 		const { name } = columns[i];
					// 		if (name === "cust_code" || name === "cust_company_name" || name === "billing_address")
					// 		{
					// 			const column_value = currentRow[i];
					// 			de("Betty-customSearch", String(searchQuery).trim());
					// 			// if (jstring(column_value).searchDeep(String(searchQuery).trim()))
					// 			// {
					// 			// 	return true;
					// 			// }
					// 		}
					// 	}
					// },
					customSearch: (searchQuery, currentRow, columns) => {
						if (!searchQuery) return true;

						const keywords = searchQuery.toLowerCase().trim().split(/\s+/);

						for (let i = 0; i < columns.length; i++) {
							const { name } = columns[i];
							if (name === "cust_code" || name === "cust_company_name" || name === "billing_address") {
								const columnValue = String(currentRow[i] || '').toLowerCase();

								let allKeywordsMatch = true;
								for (const keyword of keywords) {
									if (keyword && !columnValue.includes(keyword)) {
										allKeywordsMatch = false;
										break;
									}
								}

								if (allKeywordsMatch && keywords.length > 0) {
									return true;
								}
							}
						}
						return false;
					},
					onCellClick: (colData, { colIndex, dataIndex, rowIndex }) => {
						de("colData", colData, "colIndex", colIndex, "dataIndex", dataIndex, "rowIndex", rowIndex);
						de("headCells.length", headCells.length - 1);
						if (colIndex !== (headCells.length - 1)) {
							de("colIndex", colIndex);
							de("headCells.length", headCells.length);
							de("headCells", headCells);
							custClicked(showInactive ? inactiveCustList[dataIndex]?.cust_code : customerList[dataIndex]?.cust_code);
						}
					},
					downloadOptions: {
						filterOptions: {
							useDisplayedColumnsOnly: false,
							useDisplayedRowsOnly: true
						}
					},
					onDownload: (buildHead, buildBody, columns, data) => {
						// 找出 company 列和 billing_address 列的 index
						const companyColIndexes = columns
							.map((col, i) => (col.name === 'company' ? i : -1))
							.filter(i => i !== -1);

						const addressColIndexes = columns
							.map((col, i) => (col.name === 'billing_address' ? i : -1))
							.filter(i => i !== -1);

						const templateColIndexes = columns
							.map((col, i) => (col.name === 'tmplt_data' ? i : -1))
							.filter(i => i !== -1);

						const statusColIndexes = columns
							.map((col, i) => (col.name === 'customer_status' ? i : -1))
							.filter(i => i !== -1);

						// 处理 company 列和 billing_address 列
						const cleanData = data.map(row => {
							const cleanedRow = { ...row };

							if (Array.isArray(cleanedRow.data)) {
								cleanedRow.data = cleanedRow.data.map((cell, idx) => {
									// 处理 company 列
									if (companyColIndexes.includes(idx)) {
										// 如果 cell 是数组（多个 <Chip />）
										if (Array.isArray(cell)) {
											return cell
												.map(item =>
													item && item.props && item.props.label ? item.props.label : ''
												)
												.filter(Boolean)
												.join(', ');
										}

										// 如果是单个 React 元素
										if (cell && typeof cell === 'object' && cell.props && cell.props.label) {
											return cell.props.label;
										}
									}

									// 处理 billing_address 列
									if (addressColIndexes.includes(idx)) {
										// 如果是字符串，清理多余的换行符和空格
										if (typeof cell === 'string') {
											// 替换连续的换行符为单个空格，并去除首尾空格
											return cell.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim();
										}
									}

									// 处理 template 列
									if (templateColIndexes.includes(idx)) {
										if (Array.isArray(cell)) {
											return cell
												.filter(item => item && item.tmplt_id)
												.map(item => item.tmplt_name)
												.filter(Boolean)
												.join(', ') || '';
										}
										if (cell && typeof cell === 'object') {
											return cell.tmplt_name || '';
										}
										return '';
									}

									// 处理 status 列
									if (statusColIndexes.includes(idx)) {
										return parseInt(cell) === 1 ? language.active : language.inactive;
									}

									// 其他列不动
									return cell;
								});
							}

							return cleanedRow;
						});

						// 定义 CSV 下载的列顺序
						const desiredOrder = [
							'cust_code', 'cust_company_name', 'billing_address', 'billing_city',
							'billing_state', 'billing_zipcode', 'region', 'billing_country',
							'latitude', 'longitude', 'area_name', 'cust_category_name',
							'cust_chain_name', 'cust_type_name',
							'agent', 'cust_tel', 'ams', 'created_by',
							'created_date', 'updated_by', 'updated_at',
							'tmplt_data', 'customer_status'
						];

						// 构建重排索引：指定列在前，其余列按原顺序在后
						const colNames = columns.map(c => c.name);
						const orderedIndexes = [];
						desiredOrder.forEach(name => {
							const idx = colNames.indexOf(name);
							if (idx !== -1) orderedIndexes.push(idx);
						});
						colNames.forEach((name, idx) => {
							if (!orderedIndexes.includes(idx)) orderedIndexes.push(idx);
						});

						// 重排列头和数据
						const reorderedColumns = orderedIndexes.map(i => columns[i]);
						const reorderedData = cleanData.map(row => ({
							...row,
							data: orderedIndexes.map(i => row.data[i])
						}));

						// 交给后端产生 xlsx：CSV 会被 Excel 当数字处理，Outlet Code 变科学记数、Zipcode 丢前导零
						const exportIndexes = reorderedColumns
							.map((col, i) => (col.download === false ? -1 : i))
							.filter(i => i !== -1);

						const exportHeaders = exportIndexes.map(i => reorderedColumns[i].label || reorderedColumns[i].name);
						const exportRows = reorderedData.map(row => exportIndexes.map(i => {
							const cell = row.data[i];
							if (cell === null || cell === undefined) {
								return '';
							}
							if (typeof cell === 'object') {
								return '';
							}
							return String(cell);
						}));

						const formdata = new FormData();
						formdata.append('headers', JSON.stringify(exportHeaders));
						formdata.append('rows', JSON.stringify(exportRows));

						const downloadingKey = enqueueSnackbar(language.downloading, { variant: 'info', preventDuplicate: true, persist: true });

						API_Service.post(req_cust_excel, formdata, axiosDefaultConfig(gState.client))
							.then(({ data }) => {
								closeSnackbar(downloadingKey);
								if (data && data.result === 1 && data.extraData && data.extraData.url) {
									window.open(data.extraData.url, '_blank');
								} else {
									enqueueSnackbar(data && data.message ? data.message : language.download_failed, { variant: 'error' });
								}
							})
							.catch(() => {
								closeSnackbar(downloadingKey);
								enqueueSnackbar(language.download_failed, { variant: 'error' });
							});

						// 回传 false 让 MUIDataTable 跳过原本的 CSV 下载
						return false;
					},
					customToolbar: () => {
						return (
							<TemplateTableCustomToolbar
								showActive={!showInactive}
								onNewTemplate={() => {
									showCreateDialog(true);
								}}
								onShowInactive={setShowInactive}
								integration={integration}
							/>
						);
					},
				}}
			/>
		</MuiThemeProvider>
	)
});

function areEqual(prevProps, nextProps) {
	return prevProps.customerList.length === nextProps.customerList.length && _.isEqual(prevProps.groups, nextProps.groups);
}

function TemplateTableCustomToolbar({ showActive, onNewTemplate, onShowInactive, integration }) {
	return (
		<React.Fragment>
			{
				showActive ?
					<Tooltip title={'Show Inactive'}>
						<IconButton
							onClick={() => {
								// showActive is true, so we want to show inactive (set showInactive to true)
								onShowInactive(true);
							}}>
							<VisibilityOffIcon />
						</IconButton>
					</Tooltip>
					:
					<Tooltip title={'Show Active'}>
						<IconButton
							onClick={() => {
								// showActive is false, so we want to show active (set showInactive to false)
								onShowInactive(false);
							}}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
			}
			{
				integration === '0' ?
					<Tooltip title={'Add New'}>
						<IconButton
							edge={'end'}
							color={'primary'}
							onClick={() => onNewTemplate()} aria-label="addnew">
							<AddIcon />
						</IconButton>
					</Tooltip>
					:
					''
			}

		</React.Fragment>
	)
}

function TemplateTableToolbar({ addNewItem, showActive, onShowInactive }) {
	return (
		<React.Fragment>
			{onShowInactive && (
				showActive ?
					<Tooltip title={'Show Inactive'}>
						<IconButton
							onClick={() => {
								// showActive is true, so we want to show inactive (set showInactive to true)
								onShowInactive(true);
							}}>
							<VisibilityOffIcon />
						</IconButton>
					</Tooltip>
					:
					<Tooltip title={'Show Active'}>
						<IconButton
							onClick={() => {
								// showActive is false, so we want to show active (set showInactive to false)
								onShowInactive(false);
							}}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
			)}
			<Tooltip title={'Add New Item'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => addNewItem()} aria-label="addnew">
					<AddIcon />
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}

